import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { Marker } from 'react-leaflet'
import { DivIcon } from 'leaflet'
import _ from 'lodash'
import ReactDOMServer from 'react-dom/server'
import Icon from 'components/common/Icon'
import { getColorForIconUrl } from 'components/pointOfInterest/poiSearchResults/poiIconUtils'

const iconHTML = ({ icon, label, color, selected, iconUrl, bucketColor, isGeneral, isAlly, isCompetitor, selectedColorForIcon }) => {
  const labelHtml = label
    ? `<span class="marker-label leaflet-interactive">
        ${label}
      </span>`
    : ''

  // When iconUrl/bucketColor are provided, render a drop + masked Google icon.
  if (iconUrl || bucketColor) {
    const src = iconUrl
      ? `${iconUrl}.png`
      : 'https://maps.gstatic.com/mapfiles/place_api/icons/v2/generic_pinlet.png'
    // Background drop color: white or bucket color if grouped
    const dropColor = bucketColor ||
      (color
        ? (selected ? color.active_color : color.inactive_color)
        : '#ffffff')

    let iconColor
    if (selectedColorForIcon) {
      iconColor = selectedColorForIcon
    } else if (isCompetitor) {
      iconColor = '#000000'
    } else if (isGeneral || isAlly) {
      iconColor = '#ffffff'
    } else {
      iconColor = getColorForIconUrl(iconUrl)
    }

    const isInBucket = bucketColor && bucketColor !== '#ffffff'

    const dropSize = isInBucket ? 56 : 43
    const iconPosition = isInBucket ? '-1.1em' : '-1.3em'
    const iconSize = isInBucket ? 24 : 20
    const dropSvg = ReactDOMServer.renderToString(
      <Icon
        id='fa-drop'
        extraClasses={['map-marker__drop']}
        style={{ width: dropSize, height: dropSize, color: dropColor }}
      />
    )

    return `
      ${dropSvg}
      <div
        class="map-marker__icon"
        style="
          background-color: ${iconColor};
          -webkit-mask-image: url('${src}');
          mask-image: url('${src}');
          width: ${iconSize}px;
          height: ${iconSize}px;
          top: ${iconPosition};
        "
      ></div>
      ${labelHtml}
    `
  }

  const markerColor = color
    ? `${selected ? color.active_color : color.inactive_color}`
    : ''

  return `
    <svg style="color: ${markerColor};" class="icon">
      <use xmlns:xlink="http://www.w3.org/1999/xlink"
        xlink:href="#${icon}"></use>
    </svg>
    ${labelHtml}
  `
}

@observer class IconMarker extends Component {
  @observable icon

  componentWillMount () {
    this.icon = new DivIcon({
      className: this.props.className,
      html: iconHTML(this.props)
    })
  }

  componentWillReceiveProps (nextProps) {
    // NOTE: we use refs/lealet DOM manip to avoid map recreation
    const layer = this.refs.marker && this.refs.marker.leafletElement && this.refs.marker.leafletElement.getElement()
    const marker = this.refs.marker && this.refs.marker.leafletElement
    // Check if icon-related props changed
    const iconPropsChanged = (
      nextProps.icon !== this.props.icon ||
      nextProps.label !== this.props.label ||
      nextProps.iconUrl !== this.props.iconUrl ||
      nextProps.bucketColor !== this.props.bucketColor ||
      nextProps.isGeneral !== this.props.isGeneral ||
      nextProps.isAlly !== this.props.isAlly ||
      nextProps.isCompetitor !== this.props.isCompetitor ||
      nextProps.color !== this.props.color ||
      nextProps.selected !== this.props.selected ||
      nextProps.selectedColorForIcon !== this.props.selectedColorForIcon
    )
    // Update z-index offset if it changed
    if (marker && nextProps.zIndexOffset !== this.props.zIndexOffset) {
      marker.setZIndexOffset(nextProps.zIndexOffset || 0)
    }
    if (layer) {
      if (nextProps.className !== this.props.className) {
        const leafletClasses = _.filter(layer.classList,
          name => (/^leaflet-/g).test(name)
        )
        layer.className = `${leafletClasses.join(' ')} ${nextProps.className}`
      }

      if (iconPropsChanged) {
        layer.innerHTML = iconHTML(nextProps)
      }
    }

    // Always create new DivIcon to ensure it's up to date
    const newIcon = new DivIcon({
      className: nextProps.className,
      html: iconHTML(nextProps)
    })
    // If icon props changed, update the Leaflet marker icon
    if (iconPropsChanged && marker) {
      marker.setIcon(newIcon)
    }
    this.icon = newIcon
  }

  onDragHandler = () => {
    if (this.props.onDragEnd) {
      this.props.onDragEnd(this.refs.marker.leafletElement.getLatLng())
    }
  }

  render () {
    return this.props.position
      ? (
        <Marker
          ref='marker'
          onClick={this.props.onClick}
          onMouseDown={this.props.onMouseDown}
          onMouseOver={this.props.onMouseOver}
          onMouseOut={this.props.onMouseOut}
          onContextMenu={this.props.onContextMenu}
          onContextmenu={this.props.onContextMenu}
          position={this.props.position}
          draggable={this.props.draggable}
          icon={this.icon}
          onDragEnd={this.onDragHandler}
          zIndexOffset={this.props.zIndexOffset}
        >
          {/* IMPORTANT: We pass children so that the Tooltip can be a child of the Marker */}
          {this.props.children}
        </Marker>
        )
      : null
  }
}

export default IconMarker
